import { library } from '@fortawesome/fontawesome-svg-core';
// import { fab } from '@fortawesome/free-brands-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';

library.add(
  faEye,
  // fab,
  faTrashAlt,
  faEdit,
  faArrowLeft,
  faCheckCircle,
  faTimesCircle,
  faPlus,
  faPrint,
  faDownload,
  faTimes,
  faEyeSlash,
  faHistory,
  faArrowRight,
  faSearch,
  faRedo,
  faFilePdf,
  faFile,
  faUndo,
  faCaretRight,
  faBars,
  faCheck,
  faAngleDoubleLeft,
  faAngleDoubleRight,
);
